// extracted by mini-css-extract-plugin
export default {"btn":"QuantityBtn_btn__YLlAr","qtyBtn":"QuantityBtn_qtyBtn__3K4AN","chartBtn":"QuantityBtn_chartBtn__40hfB","qty":"QuantityBtn_qty__Qen36"};